<template>
    <div class="panel  panel-info">
        <div class="panel-heading">
            我的资料
        </div>
        <div class="panel-body" style="height: 570px">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
                    <div class="col-sm-6 col-sm-offset-2">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">用户名</label>
                            <div class="col-sm-6">
                                <input type="text" name="yhm" readonly v-model="model.yhm"
                                    class="form-control"
                                    placeholder="">
                                <!-- <span class="error_validate_msg"><em>{{ errors.first('yhm') }}</em></span> -->
                            </div>

                        </div>
                    </div>
                    <div class="col-sm-6 col-sm-offset-2">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">角色</label>
                            <div class="col-sm-6">
                                <input type="text" name="js" readonly v-model="jsList[this.model.js]"
                                       class="form-control"
                                       placeholder="">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-sm-offset-2">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">机构类型</label>
                            <div class="col-sm-6">
                                <input type="text" name="jglx" readonly v-model="jglxList[model.jglx]"
                                       class="form-control" placeholder="">
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 col-sm-offset-2">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">机构</label>
                            <div class="col-sm-6">
                                <input type="text" name="jgdmmc" readonly v-model="model.jgdmmc" class="form-control"
                                       placeholder="">
                            </div>
                        </div>
                    </div>
                    <!--zsxm-->
                    <div class="col-sm-6 col-sm-offset-2">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">真实姓名</label>
                            <div class="col-sm-6">
                                <input type="text" name="zsxm" readonly v-model="model.zsxm" class="form-control"
                                       placeholder="">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-sm-offset-2">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">手机号</label>
                            <div class="col-sm-6">
                                <input type="text" name="sjh" v-validate="{required:true}" data-vv-as="手机号"
                                       v-model="model.sjh" class="form-control" placeholder="">
                                <span class="error_validate_msg"><em>{{ errors.first('sjh') }}</em></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-sm-offset-2">
                        <div class="form-group">
                            <label class="col-sm-3 control-label">状态</label>
                            <div class="col-sm-6">
                                <input type="text" name="zt" readonly v-model="ztList[model.zt]" class="form-control"
                                       placeholder="">
                            </div>
                        </div>
                    </div>
                </form>
                <!--头像-->
                <div style="height: 40px;line-height: 40px;">点击更换头像</div>
                <image-upload class="image-upload" v-model="model.img"></image-upload>

            </div>
            <div style="padding-top: 50px">
                <center>
                    <button class="btn btn-primary" type="button" @click="save()">保存</button>

                </center>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: "PersonCenter",
        components:{
        },
        data: function () {
            return {
                jsList: [],
                jglxList: [],
                ztList: [],
                model: {
                    id: '',
                    yhm: '',
                    js: '',
                    jglx: '',
                    jgdm: '',
                    jgmc: '',
                    zsxm: '',
                    img: '/img/user1.e8a3536a.jpg',
                    jgdmmc: '',
                    sjh: '',
                    zt: ''
                },
            }
        },
        mounted() {
            // console.log(this.model)
        },


        created: function () {

            this.$store.commit('setBreadcrumb', [{name: '个人中心'}]);
            this.$store.commit('setShowReturnBackBtn',true);
            this.getinfo();
            this.jsList = {
                'ADMIN': '超级管理员'
            };
            this.jglxList = {
                'PLATFORM': '平台',
				'COMPANY': '集团公司',
				'ZKXX': "主考学校",
				'ZXJG': "助学机构"
            };
            this.ztList = {'OK': "正常", 'BLOCK': "禁用"}
        },
        methods: {
            //点击传递  更换头像
            uploadHeadImg: function () {
                this.$el.querySelector('.image-upload').click()
            },

            getinfo: function () {
                this.$http.post('/htgl/grzx/hq').then(res => {
                    res.data.jgdmmc = res.data.jgdm + '-' + res.data.jgmc //机构代码+名称
                    this.model = res.data
                    console.log(this.model.img)
                    let tmp = this.model.img;
                    if (!tmp && typeof(tmp) != "undefined" && tmp != 0) {  //判断img值是为null
                        this.model.img ='/img/user1.e8a3536a.jpg'   //设置初始头像
                    }
                })

            },

            //保存
            save() {
                // console.log(this.$store.state.user.yhm)
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        console.log(this.model)
                        this.$http.post('/htgl/grzx/xg', {
                            yhId:this.model.id,
                            yhm:this.model.yhm,
                            sjh:this.model.sjh,
                            img:this.model.img,
                        }).then(res => {
                            if (res.code == 0) {
                                this.$store.state.user.yhm=res.data.yhm
								this.$success('操作成功');
                            }
                        })

                    }
                })

            }

        }

    }
</script>
<style scoped>
    .form-group .control-label {
        font-weight: bold;
        color: #666;
    }

    .photo {
        /*background-color: #1f1f1f;*/
        /*border-radius: 999px;*/
    }

    .hiddenInput {
        display: none;
    }
    .image-upload {
        /*width: 170px ;*/
        /* height: 200px !important */
        height: auto;
        overflow: hidden;
    }
    .image-upload img{
        height: 200px !important
    }
</style>
